import './rxjs-extensions';

import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DndModule } from 'ng2-dnd';
import { SpinnerModule } from '../spinner/spinner.module';

import { ReportCompComponent } from './report.component';
import { ReportRoutingModule } from './report.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReportRoutingModule,
    ReactiveFormsModule,
    SpinnerModule,
    DndModule.forRoot()
  ],
  exports: [
    ReportCompComponent
  ],
  declarations: [
    ReportCompComponent
  ],
  providers: [
    GenericdatasetService
  ]
})
export class ReportCompModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ReportCompModule,
      providers: [GenericdatasetService]
    };
  }
}
